import { Box } from '@mui/material';

/** Cream canvas only. No highway, no photos. */
export function AuthRoadBackdrop() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        pointerEvents: 'none',
        bgcolor: '#F4F1EB',
      }}
    />
  );
}
